package com.starparty.app.astro0.readers

import com.starparty.app.astro0.Constellation

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
object ConstellationReader {
    fun makeConstellations( /*InputStream is*/): Array<Constellation> {
        val consTemp: MutableList<Constellation> = mutableListOf()
        val conData = readConstellationData()
        val titleRA = 0.0
        val titleDec = 0.0
        var conNum = 0
        for (con in conData) {

            consTemp.add(Constellation(
                conNum,
                Constellation.NAMES[conNum][Constellation.ABB],
                Constellation.NAMES[conNum][Constellation.NAME],
                conData[conNum])
            )

            conNum++
        }

        return consTemp.toTypedArray()
    }

    internal fun readConstellationData( /*InputStream is*/): Array<String> {
        val conDataTemp: MutableList<String> = mutableListOf()

        for (line in mlines) {
            if (line != null && line.length > 0) {
                conDataTemp.add(line)
            }
        }

        return conDataTemp.toTypedArray()
        /*
    try
    {
      BufferedReader in = new BufferedReader(new InputStreamReader(is));

      int con = 0;
      while(in.ready())
      {
        String line = in.readLine();

        if ((line != null) && (line.length() > 0))
        {
          conData[con] = line;
          con++;
        }
      }

      in.close();
    }
    catch (IOException ex) { ex.printStackTrace(); }
*/

    }

    private val mlines = arrayOf(
        "And 0-3-1-9-2,8-14-3-16-12-10-6,12-5,1-7-18,9-4,",
        "Ant 2-0-3-1,",
        "Aps 0-3-1-2,",
        "Aqr 5-0-1-6-4-2-3-7-12-4,",
        "Aql 2-1-0-6-3-7-11-5-4-0,",
        "Ara 4-3-0-1-7-2-6,2-3,",
        "Ari 3-2-0-1-8,",
        "Aur 6-1-2-3-5-4-7-5-0-1,",
        "Boo 8-1-0-2-4-5-3-6-0-11,",
        "Cae 1-0,",
        "Cam 1-2,",
        "Cnc 2-4-1-3,1-0,1-5,",
        "CVn 0-1,",
        "CMa 4-8-2-7-1-5,2-6-0-3,0-15-13-12,0-10-9-7,",
        "CMi 0-1,",
        "Cap 2-1-7-6-4-0-3-5-1,",
        "Car 0-7-2-3-4-6-1-5,",
        "Cas 4-3-2-5-0-1,0-6,",
        "Cen 9-21-3-20-6-12,3-13-10-7-5-4-18-8-19-17-11,0-5-1,",
        "Cep 1-2-0-7-3-6-5-2,",
        "Cet 4-13-12-18-1-4-2-8-7-3-0-6-3-5-8,5-9,",
        "Cha 2-1-0-3-4-2,",
        "Cir 2-0-1,",
        "Col 3-0-1-4,1-5-6-2,",
        "Com 1-0-3-2,",
        "CrA 5-6-0-1-2-4-3,",
        "CrB 3-1-0-2-5-4-9,",
        "Crv 3-1-2-0-3-4,",
        "Crt 4-6-0-2-3-1-0,2-5-8,",
        "Cru 2-3,0-4,",
        "Cyg 0-1-11-4,5-2-1-3-9-8,",
        "Del 2-0-1-3-4-0,",
        "Dor 2-0-4-1-3-6,7-3-5,",
        "Dra 8-28-2-0-8-3-9-6-4-1-12-5-7-11-10,",
        "Equ 1-3-0-2,",
        "Eri 22-1-25-15-13-16-2-26-4-9-12-28-17-7-21-19-10-14-6-3-18-20-5-8-0,",
        "For 0-1-2,",
        "Gem 13-0-2-5-3-1-12-8-0-9,8-10,1-7,3-6,",
        "Gru 2-9-10-5-1-3-7,8-4-1-0,",
        "Her 8-0-1-6-3-14-1,0-2-20-4-7-10,14-2-5,9-12-3,6-15-13-17,",
        "Hor 0-8-6-4-3-2,",
        "Hya 2-14-18-12-5-2-9-10-0-11-7-8-3-6-13-1-4,",
        "Hyi 1-5-3-4-0-2,",
        "Ind 0-2-1,2-3,",
        "Lac 1-5-2-0-3-7-2,",
        "Leo 7-0-5-1-2-3-8-0,3-6-11-4,5-12-13-15,",
        "LMi 0-1-2,",
        "Lep 3-0-7-5-1-0-4-6-12,1-2,",
        "Lib 11-6-5-0-1-2-3-4,0-2,",
        "Lup 10-8-3-1-0-5-9-4-2-3,2-6-13,",
        "Lyn 0-1-2-5-3-4,2-6,",
        "Lyr 3-6-2-1-4-6-0-5,",
        "Men 2-4-1-0,",
        "Mic 3-0-1-2,",
        "Mon 6-4-1-7-2-0-3,",
        "Mus 3-5-0-2,1-0-4,",
        "Nor 1-0-2,0-3-4,",
        "Oct 0-1-2-0,",
        "Oph 1-2-6-3-11-5-0-4-10-1,",
        "Ori 5-4-1-10-2-6-0-5,2-8-12-13,8-21-15,1-17-24-23,",
        "Pav 0-1-4-5-3-8-9-6-2-1-7,",
        "Peg 14-9-6-1-4-8-11-10,3-2-1,2-12-5-7-0,",
        "Per 10-2-12-3-8-5-0-4-7,0-14-16,0-9-1-6-18,5-13-21-17-28-20,",
        "Phe 6-2-1-0-3-10-15,1-4-7-3,",
        "Pic 1-2-0,",
        "Psc 3-6-1-21-11-3-2-9-5-10-7-4-0-17-18-12,",
        "PsA 0-1-12-11-9-4-8-3-5-2-0,",
        "Pup 9-8-6-7-1-4-3-5-0-2-8,",
        "Pyx 1-0-2,",
        "Ret 0-1-4-2-0,",
        "Sge 0-1-2,1-3,",
        "Sgr 7-0-3-4-8-2-9-30-22-19-18-16-14,16-15,9-1-8,1-11-5-13,11-10,3-6-20,4-12,6-0-2,",
        "Sco 2-11-5-2-13-15-14-12-3-8-0-10-20-4-17-19-18-6,4-9-16,",
        "Scl 0-3-2-1,",
        "Sct 1-0-3,0-2,",
        "Ser 4-8-9-4-6-0-5-2,15-1-14-10-3,",
        "Sex 2-0-1,",
        "Tau 1-6-12-9-5-11-7,3-0-4-9,5-22-15,6-2,",
        "Tel 1-0-2,",
        "Tri 0-1-2-0,",
        "TrA 0-1-2-0,",
        "Tuc 4-0-1-3-2-5-1,",
        "UMa 2-3-0-10-5-4-1-10,4-9-17-15-11-24-23-1,9-8,9-14,5-16-6-7,6-12,16-13,",
        "UMi 0-6-3-5-1-2-8-5,",
        "Vel 0-1-3-5-4-6-2-0,",
        "Vir 7-2-3-12-10-4-9-6-15-0-13-11-8,6-3-1,",
        "Vol 4-0-5-2-1-3-5,",
        "Vul 3-1-4-2-0-5,"
    )
}